import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePromise } from '../../../Utils/usePromise';
import axios from 'axios';
import Card from 'reactstrap/es/Card';
import CardTitle from 'reactstrap/es/CardTitle';
import Spinner from 'reactstrap/es/Spinner';
import CardText from 'reactstrap/es/CardText';
import { parseApiError } from '@yooink/youtils/es/ParseApiError';
export function ReviewsCount({ from, to, color }) {
    const { isLoading, isError, data = {}, errData } = usePromise(() => {
        return axios.get(`/api/v2/analytics/badges/reviewsCount`, { params: { from, to } })
            .then((res) => res.data);
    }, [from.getTime(), to.getTime()]);
    const { count } = data;
    return (_jsxs(Card, Object.assign({ body: true, className: color }, { children: [_jsx(CardTitle, { children: "\u041E\u0442\u0437\u044B\u0432\u043E\u0432" }), isLoading && _jsx(Spinner, {}), !isLoading && !isError && (_jsx("div", Object.assign({ className: "card_footer" }, { children: _jsxs("div", Object.assign({ className: "count" }, { children: [_jsxs("span", Object.assign({ className: "size-3" }, { children: [count, " "] })), " \u0448\u0442"] })) }))), !isLoading && isError && (_jsx(CardText, { children: parseApiError(errData) }))] })));
}
